import './mail-outgoing-selection-workspace.ajscss';

import { IPhoneActionsService } from '@agent/agent-interface/contact-view/phone/phone-actions.service';
import { IOutgoingMailDeprecatedFacade } from '@agent/core/channel-digit/mail/outgoing-mail-deprecated.service';
import { ISmsDeprecatedService } from '@agent/core/channel-digit/sms/sms-deprecated.service';
import { IAppointmentDeprecatedService } from '@agent/core/contact/appointment-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IQualificationDeprecatedService } from '@agent/core/contact/qualification-deprecated.service';
import { ICustomerCardsDeprecatedService } from '@commons/customer/customer-cards-deprecated.service';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions } from 'angular';

import { CustomerFacade, DisplayDeprecatedComponent, MessagingService, Option } from '@contact/upgrade';

import templateUrl from './mail-post-treatment-actions.template.html';

const MODULE_NAME = 'contactMailPostTreatmentActions';

class MailPostTreatmentActionsCtrl extends DisplayDeprecatedComponent implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;
  canRenewPostTreatment = false;
  canFinishPostTreatment = false;

  hasCustomCardsSelectionDialog: boolean = false;

  constructor(
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly phoneActions: IPhoneActionsService,
    private readonly qualificationDeprecatedService: IQualificationDeprecatedService,
    private readonly smsDeprecatedService: ISmsDeprecatedService,
    private readonly appointmentDeprecatedService: IAppointmentDeprecatedService,
    protected readonly messaging: MessagingService,
    private readonly customerCardsDeprecatedService: ICustomerCardsDeprecatedService,
    private readonly outgoingMailDeprecatedFacade: IOutgoingMailDeprecatedFacade,
    private readonly customerFacade: CustomerFacade
  ) {
    super();
  }

  $onInit(): void {
    this.qualificationDeprecatedService.canRenewPostTreatment(this.responseId).then(can => (this.canRenewPostTreatment = can));
    this.qualificationDeprecatedService
      .canFinishPostTreatment(this.responseId)
      .pipe(ng1Destroy(this))
      .subscribe(can => (this.canFinishPostTreatment = can));

    // retrieve the customerCards if still not choosen by csr
    this.contactDeprecatedService.getContact(this.responseId).then(_contact => {
      if (!_contact.customerId) {
        this.hasCustomCardsSelectionDialog = true;
        this.customerCardsDeprecatedService.displayPresomption(_contact.phoneNumber);
      }
    });
  }

  $onDestroy(): void {
    if (this.hasCustomCardsSelectionDialog) {
      this.customerFacade.closeSelectDialog();
    }
  }

  finish(): void {
    this.phoneActions.finish(this.responseId);
  }

  renew(): void {
    this.phoneActions.renewPostTreatment(this.responseId).then(() => {
      this.qualificationDeprecatedService.canRenewPostTreatment(this.responseId).then(canRenew => {
        this.canRenewPostTreatment = canRenew;
      });
    });
  }

  openSMSForm(): void {
    this.contactDeprecatedService.getSelectedContact().then(contact => {
      contact.customerId && this.smsDeprecatedService.openSMSForContact(contact.customerId);
    });
  }

  openUnitMail(): void {
    this.contactDeprecatedService.getSelectedContact().then(contact => {
      this.outgoingMailDeprecatedFacade.openOutgoingMailForContactUuid(
        Option.of(contact.customerId).getOrElse(contact.customerId || ''),
        this.responseId
      );
    });
  }

  openAppointmentForm(): void {
    this.contactDeprecatedService.getSelectedContact().then(contact => {
      this.contactDeprecatedService.getCustomer(contact.responseId).then(customer => {
        let firstName: string;
        let lastName: string;
        if (!!customer) {
          firstName = customer.firstname;
          lastName = customer.lastname;
        } else {
          firstName = contact.customerName;
          lastName = '';
        }
        this.appointmentDeprecatedService.openAppointmentForm(contact.responseId, contact.phoneNumber, firstName, lastName, contact.skills);
      });
    });
  }
}

export class MailPostTreatmentActions implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = [
    'contactDeprecatedService',
    'phoneActions',
    'qualificationDeprecatedService',
    'smsDeprecatedService',
    'appointmentDeprecatedService',
    'messaging',
    'customerCardsDeprecatedService',
    'outgoingMailDeprecatedService',
    'customerFacade',
    MailPostTreatmentActionsCtrl,
  ];
}

export default MODULE_NAME;
